// src/layout/Header.jsx
import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";

const Header = ({ onLogout }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen((prev) => !prev);
  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="bg-[#4B2E2B] text-white px-6 py-3 flex justify-between items-center shadow-md relative">
      {/* Ліва частина */}
      <div className="flex items-center gap-4">
        {location.pathname !== "/dashboard" && (
          <button
            onClick={() => navigate(-1)}
            className="bg-[#A47551] px-3 py-1 rounded hover:bg-[#8B5E3C] text-sm sm:text-base"
          >
            ← Назад
          </button>
        )}
        <h1 className="font-bold text-lg sm:text-xl">Zakhid Wood Admin</h1>
      </div>

      {/* Навігація для великих екранів */}
      <nav className="hidden md:flex gap-4 items-center">
        <Link to="/dashboard" className="hover:underline">
          Панель
        </Link>
        <Link to="/products" className="hover:underline">
          Товари
        </Link>
        <Link to="/categories" className="hover:underline">
          Категорії
        </Link>
        <button
          onClick={onLogout}
          className="bg-red-600 px-3 py-1 rounded hover:bg-red-700"
        >
          Вийти
        </button>
      </nav>

      {/* Кнопка бургер (для мобільних) */}
      <button
        onClick={toggleMenu}
        className="md:hidden text-2xl focus:outline-none"
      >
        {menuOpen ? <FaTimes /> : <FaBars />}
      </button>

      {/* Мобільне меню */}
      {menuOpen && (
        <div className="absolute top-full left-0 w-full bg-[#4B2E2B] text-white flex flex-col items-center gap-4 py-6 shadow-lg z-50 animate-fadeIn">
          <Link
            to="/dashboard"
            onClick={closeMenu}
            className="hover:underline text-lg"
          >
            Панель
          </Link>
          <Link
            to="/products"
            onClick={closeMenu}
            className="hover:underline text-lg"
          >
            Товари
          </Link>
          <Link
            to="/categories"
            onClick={closeMenu}
            className="hover:underline text-lg"
          >
            Категорії
          </Link>
          <button
            onClick={() => {
              onLogout();
              closeMenu();
            }}
            className="bg-red-600 px-4 py-2 rounded hover:bg-red-700 text-lg"
          >
            Вийти
          </button>
        </div>
      )}
    </header>
  );
};

export default Header;
